import { OnInit, Type } from '@angular/core';
import { PersonalAccidentsResumeComponent } from '../risks/personal-accidents/ui/components/personal-accidents-resume/personal-accidents-resume.component';
import { TransportationGoodsResumeComponent } from '../risks/transport/ui/components/transportation-goods-resume/transportation-goods-resume.component';
import { ClassicCarResumeComponent } from '../risks/classic-car/ui/components/classic-car-resume/classic-car-resume.component';
import { MotorBikeResumeComponent } from '../risks/motor-bike/ui/components/motor-bike-resume/motor-bike-resume.component';
export interface AnyAngularComponent extends Partial<OnInit> {
  [key: string]: any;
}

export const riskSidebarMap: Record<string, Type<AnyAngularComponent>> = {
  transportation_goods: TransportationGoodsResumeComponent,
  personal_accidents: PersonalAccidentsResumeComponent,
  classic_car: ClassicCarResumeComponent,
  motor_bike: MotorBikeResumeComponent,
};
